export const profileColor = (username) => {
    var val = (username?.length ?? 0) % 4;
    switch(true){
        case(val <= 0):{
            return '#DE7171'
        }
        case(val <= 1):{
            return '#DEA871'
        }
        case(val <= 2):{
            return '#DEDE71'
        }
        case(val <= 3):{
            return '#66896B'
        }
        case(val <= 4):{
            return '#71DEA8'
        }
        default:{
            return '#C2C2C2'
        }
    }
}